import { inject } from '@angular/core';
import { type CanActivateFn, Router, UrlTree } from '@angular/router';
import { SupabaseService } from '@app/core/supabase.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const supabase = inject(SupabaseService);

  // 1. Check the session directly from the SDK (Synchronous/Fast Local Check)
  // We use getSession() because it handles token refresh automatically if needed.
  const { data: { session } } = await supabase.client.auth.getSession();

  // 2. Not Authenticated? -> Redirect to Login
  if (!session) {
    console.log('AuthGuard: User not authenticated, redirecting to /login');
    return router.createUrlTree(['/login']);
  }

  // 3. Email Verification Check (Optional)
  // Supabase normally blocks login for unverified users if you configured it that way.
  // But if you allow "unverified login", this block forces them to verify.
  const user = session.user;
  const isEmailConfirmed = user?.email_confirmed_at || user?.app_metadata?.['email_verified'];

  if (user && !isEmailConfirmed) {
    console.log('AuthGuard: Email not verified, redirecting to /verify-required');
    // alert('Please verify your email address.'); // Optional alert
    return router.createUrlTree(['/verify-required']);
  }

  // 4. Success
  return true;
};